import { CSSProperties, ReactNode, HTMLAttributes } from "react";
import css from "./link.module.scss";
import BaseLink from "../base-link/base-link";

export enum LinkType {
  BUTTON = "button",
  DEFAULT = "default",
}

export enum LinkStyle {
  PRIMARY = "primary",
  SECONDARY = "secondary",
}

interface ILinkProps extends HTMLAttributes<HTMLAnchorElement> {
  children: ReactNode;
  href: string;
  className?: string;
  linkType?: LinkType;
  linkStyle?: LinkStyle;
  style?: CSSProperties;
  dataCtaId?: string;
  dataCtaValue?: string;
}

const Link = (props: ILinkProps) => {
  const {
    children,
    className = "",
    href,
    linkType,
    linkStyle,
    style,
    dataCtaId,
    dataCtaValue,
    ...rest
  } = props;

  return (
    <BaseLink
      href={href}
      className={`${css.link} ${linkType ? css[linkType] : ""} ${
        linkStyle ? css[linkStyle] : ""
      } ${className}`}
      style={style}
      data-cta-id={dataCtaId}
      data-cta-value={dataCtaValue}
      {...rest}
    >
      {children}
    </BaseLink>
  );
};

export default Link;
